import * as React from 'react';
import StringResources from '../utils/stringResources';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../store';
import { Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core';
import { ReactElementLike, ReactNodeLike } from 'prop-types';

const useStyles = makeStyles(theme =>
  createStyles({
    endDateRange: {
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '15px',
    },
    startDateRange: {
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '15px',
    },
    dialogLabel: {
      fontSize: '1.1rem',
      display: 'inline',
    },
    dialogLabelBold: {
      fontSize: '1.1rem',
      display: 'inline',
      fontWeight: 'bold',
    },
    dialogTitle: {
      textAlign: 'center',
      fontSize: '1.7rem',
      color: '#23496B',
      fontWeight: 'bold',
    },
    errorMessage: {
      color: '#FF0000',
    },
    commandLabel: {
      fontWeight: 'bold',
      textDecoration: 'underline',
      fontSize: '1.3rem',
    },
    overViewTitle: {
      fontWeight: 'bold',
      fontSize: '1.7rem',
    },
    applySnapshotTitle: {
      fontWeight: 'bold',
      textDecoration: 'underline',
      fontSize: '1.9rem',
    },
    importCSVlabel: {
      height: 40,
      minWidth: 160,
      marginTop:10,
      fontSize: '1.1rem',
      fontWeight: 'bold',
    },
  })
);
interface Props {
  stringKey?: string;
  style?: any;
  label?: string;
  variant?: any;
  gutterBottom?: boolean;
  dataTestId?: string;
  component?: any;
  hidden?: boolean;
  text?: string;
}
export const getLanguageStringResource = () => {
  const selectedLanguage: string = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.selectedLanguage
  );
  const seletedLanguage: string = selectedLanguage;
  const stringResources = StringResources;
  const lang = seletedLanguage;
  switch (lang) {
    case StringResources.English.ENGLISH_OPTION:
      return stringResources.English;
    case StringResources.English.FRENCH_OPTION:
      return stringResources.French;
    default:
      return stringResources.English;
  }
};

export const GetString = (stringKey: any) => {
  var string = stringKey;
  var stringResources: any = getLanguageStringResource();

  string = stringResources[stringKey];
  return string;
};

interface Props {
  stringKey?: string;
  style?: any;
  label?: string;
  variant?: any;
  gutterBottom?: boolean;
  dataTestId?: string;
  component?: any;
  hidden?: boolean;
  text?: string;
}

const StringResourceManager: React.FC<Props> = ({
  stringKey,
  style,
  label,
  variant,
  gutterBottom,
  dataTestId,
  component,
  hidden,
  text,
}): React.ReactElement => {
  const className: any = useStyles();

  var getStringValue = GetString(stringKey);
  return (
    <Typography
      className={className[style]}
      variant={variant}
      gutterBottom={gutterBottom}
      data-testid={dataTestId}
      component={component}
      hidden={hidden}
    >
      {text} {getStringValue == undefined ? stringKey : getStringValue} {label}
    </Typography>
  );
};
export default StringResourceManager;
